// extracted by mini-css-extract-plugin
module.exports = {"filterBarContainer":"FilterBar_filterBarContainer__3lI-I","resultsText":"FilterBar_resultsText__ijDMn"};